export default "__VITE_ASSET__946c233f__"